import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UUID} from '../../models/uuid';
import {SpinnerComponent} from 'src/lib/components/spinner/spinner.component';
import {FileExt, getFileExtension, MotiFileType} from '../../models/moti-file-type';
import { DataSourceService } from 'src/moti/services/data-source.service';
import { ShadeService } from 'src/moti/services/shade.service';


@Component({
  selector: 'moti-download-source-icon',
  templateUrl: './download-source-icon.component.html',
  styleUrl: './download-source-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SpinnerComponent,
  ],
})
export class DownloadSourceIconComponent implements OnInit {
  @Input() dataSourceId: UUID;
  @Input() mimeType: MotiFileType;

  extension: FileExt;
  preparingDownload: boolean = false;


  constructor(
    private dataSourceSvc: DataSourceService,
    private shade: ShadeService,
  ) {
  }


  ngOnInit() {
    if (this.mimeType) {
      this.extension = getFileExtension(this.mimeType);
    }
  }


  downloadFile(id: UUID) {
    const windowRef = window.open();

    this.preparingDownload = true;
    this.dataSourceSvc.getSignedUrl$(id).subscribe({
      next: (url) => {
        windowRef.location = url;
      },
      error: () => {
        this.shade.errorDialog();
        this.preparingDownload = false;
      },
      complete: () => {
        this.preparingDownload = false;
      },
    });
  }


  downloadIcon = `<i class="fa-regular fa-fw fa-arrow-down-to-bracket"></i>`;
}
